import { Box, Container, Flex, Grid, GridItem, useMediaQuery } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import React, { FunctionComponent } from 'react';
import { withTranslations } from 'store/translations';

import { LinkType } from '../../lib/enums/LinkType';
import { OverviewItemModel } from '../../utils/types/overviewItemModel';
import { Link } from '../base/Link';
import { OverviewItem } from './OverviewItem';

interface OverviewSpotAutomaticNewsProps {
  newsItems: OverviewItemModel[];
}

export const OverviewSpotAutomaticNews: FunctionComponent<OverviewSpotAutomaticNewsProps> = ({ newsItems }) => {
  const { common, multiple } = withTranslations();
  const router = useRouter();
  // const locale = router.locale === process.env.NEXT_PUBLIC_DEFAULT_LOCALE! ? '' : `/${router.locale}`;

  const [isSmallScreen] = useMediaQuery('(max-width: 768px)');

  return (
    <Container>
      <Flex flexDir='column' py={{ base: 'm', md: 'l' }} w='100%'>
        <Flex
          flexDir={'row'}
          alignItems='center'
          justifyContent='space-between'
          gap='xs'
          pb={{ base: 'mobile.l', lg: 'desktop.l' }}
        >
          <Flex flexDir={'row'} alignItems='stretch' gap='desktop.xs'>
            <Box
              w={'2px'}
              borderWidth={'0px 1px'}
              borderStyle={'solid'}
              borderColor={'cyan.web'}
              borderRadius={'8px'}
            ></Box>
            <Box
              textStyle={{ base: 'mobile.body.medium.xs', lg: 'desktop.body.medium.xs' }}
              position={{ base: 'sticky', lg: 'relative' }}
            >
              {common('latestNews').toUpperCase()}
            </Box>
          </Flex>
          <Box textStyle={'desktop.s'}>
            <Link
              href={multiple('news')}
              type={LinkType.SecondaryButton}
              iconName='chevronRightForLink'
              weight={'680'}
              locale={router.locale}
              isPrDisabled={true}
            >
              {common('readMore')}
            </Link>
          </Box>
        </Flex>

        {newsItems.length < 3 || !isSmallScreen ? (
          <Grid
            templateColumns={{
              base: 'repeat(1, 1fr)',
              lg: `repeat(3, 1fr)`,
            }}
            gap={{ base: 'desktop.m', md: 'var(--chakra-space-desktop-xl) var(--chakra-space-desktop-m)' }}
          >
            {newsItems.map((item) => (
              <GridItem key={item.id}>
                <OverviewItem model={item} />
              </GridItem>
            ))}
          </Grid>
        ) : (
          <Flex
            flexDir={'row'}
            pb='s'
            overflow='auto'
            gap='desktop.m'
            sx={{
              '::-webkit-scrollbar': {
                bg: 'white',
                height: '3px',
              },
              '::-webkit-scrollbar-thumb': {
                bg: 'cyan.web',
              },
            }}
          >
            {newsItems.map((item, index) => (
              <GridItem key={index} minW={'73%'}>
                <OverviewItem model={item} />
              </GridItem>
            ))}
          </Flex>
        )}
      </Flex>
    </Container>
  );
};
